import { Theme } from "@mui/material";
import { einsteinTheme } from "@tiny/theme/createTheme";
import createSamCartTheme from "@tiny/theme/createSamCartTheme";

// Built once and shared by every consumer (the outer, URL-guessed theme in
// ProviderThemeProvider and the authoritative, account-API-driven override
// in RootRoute) so a SamCart account never pays for building it twice.
let samCartTheme: Theme | undefined;

export const getThemeForProvider = (
  provider: string | null | undefined
): Theme => {
  if (provider?.toLowerCase() !== "samcart") return einsteinTheme;
  samCartTheme ??= createSamCartTheme();
  return samCartTheme;
};
